import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withWidth, withStyles } from "@material-ui/core";
import style from './styles.module.scss';
import styled from 'styled-components';
import SecondaryNav from './../components/SecondaryNav';
import SingleAndParcelsTabs from './../components/SingleAndParcelsTabs';
import { Link } from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "./../../../../redux/actions/auth";
import * as DiamondsActions from "./../../../../redux/actions/diamonds";
import Button from '@material-ui/core/Button';
import numeral from 'numeral';
import d from "final-form-arrays";
import { isOtherShape } from 'logged_out/components/diamonds/All';
import getSymbolFromCurrency from 'currency-symbol-map';
import { convertToCurrency } from 'shared/functions/priceCalc';

const styles = theme => ({
    noDecoration: {
        textDecoration: "none !important"
    }
});

function joinHenigArray(d, field) {
    return d[field][0] && [d[field][0].From, d[field][1].To].filter(s => s).join(' to ') || '';
}

const FavouriteItem = styled(({ className, onCloseClick, isUnavailable, diamondItem, isParcel, isCompare, toggleCompare }) => <div className={classNames(className)}>
    <div className="tools">
        <div className="item-code">
            {!isUnavailable && <span>{diamondItem.StkCodeCalcNS || '-'}</span>}
        </div>
        <div>
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleCompare(!isCompare); }} className={`hoverSwitchMargin ${!isCompare && "hoverSwitch" || ""}`} style={{ paddingTop: 6 }}>
                {!isCompare && <React.Fragment>
                    <img alt="" src="/images/compare.svg" />
                    <img alt="" className={"hover"} src="/images/compare_hover.svg" />
                </React.Fragment>}
                {isCompare && <img alt="" src="/images/compare_active.svg" />}
            </IconButton>
            <i className="fav-icon" onClick={onCloseClick} title="Remove from Favourites" />
        </div>
    </div>
    <div className="thumb">
        <img alt="" src={diamondItem.img} />
    </div>
</div>)`
display: inline-block;
padding: 35px;
padding-bottom: 0;
width: 100%;

.item-code{
  height: 17px;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;
}

i{
    width: 24px;
    height: 24px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    margin-top: -4px;
}
.fav-icon{
    background-image: url(/images/fav_active_2.svg);
    :hover{
        opacity: 0.8;
    }
}

.tools{
    display: flex;
    justify-content: space-between;
    margin-left: -12px;
    margin-right: -12px;
    
    .hoverSwitchMargin{
        margin-top: -18px;
        margin-right: 8px;
    }
    .hoverSwitch {
        .hover {
            display: none;
        }

        &:hover {
            img {
                display: none;
            }

            .hover {
                display: inline-block;
            }

        }
    }
}
.thumb{
    width: 121px;
    height: 120px;
    background-color: transparent;
    box-sizing: content-box;
    border-radius: 50%;
    position: relative;
    margin: 0 auto;

    img{
        width: 100%;
        height: auto;
        object-fit: contain;
        position: relative;
        z-index: 1;
        margin-top: -15px;
    }

    ::before {
        content: "";
        width: 70px;
        height: 10px;
        position: absolute;
        margin-top: 150px;
        background-color: black;
        border-radius: 50%;
        display: block;
        z-index: 0;
        filter: blur(10px);
        opacity: 0.5;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
    }
}
&.active .thumb{
    background-color: #f7f4f1;
}
`;

class Fav extends PureComponent {
    state = {
        sideDrawerOpen: false,
        tabsValue: 0,
        row: false,
    }

    componentDidMount() {
        const { selectFav = () => { } } = this.props;
        //const { diamondId, page } = this.props.match.params;

        selectFav();
    }

    openBag = (row) => {
        this.props.AuthActions.addToBag(row, () => {
            this.setState({ sideDrawerOpen: 'bag', row });
        });
    };
    openBagShare = () => {
        this.setState({ sideDrawerOpen: 'share' });
    };
    openPrice = () => {
        this.setState({ sideDrawerOpen: 'price' });
    };
    closeBag = () => {
        this.setState({ sideDrawerOpen: false, row: false });
    };

    onTabsChange = (e, tabsValue) => {
        this.setState({ tabsValue });
    };

    removeFromCompared(item) {
        const { favouriteItemsList } = this.props;
        this.props.DiamondsActions.setFavourite(favouriteItemsList.filter(c => c._id !== item._id))
    }

    convertToCurrency(amount, isParcel) {
        const { fxrates = [], ccy } = this.props;
        return convertToCurrency(amount, isParcel, fxrates, ccy);
    }

    toggleCompare(_id, value) {
        const { compareItemsList } = this.props;
        this.props.DiamondsActions.setCompare(value ? [...compareItemsList, _id] : compareItemsList.filter(c => c !== _id));
    }

    render() {
        const { sideDrawerOpen, tabsValue, row } = this.state;
        let { classes, /* authUser, */ isAuthorised, favouriteItemsList = [], diamondsDocs = [], areDiamondsLoading, fxrates = [], ccy, compareItemsList } = this.props;
        //const { diamondId, page } = this.props.match.params;

        const isSingleLabs = tabsValue === 1;
        const isParcel = tabsValue === 2;

        diamondsDocs = diamondsDocs ? diamondsDocs : [];

        const favouritesItemsListInTab = favouriteItemsList
            .filter(a => (isParcel && a.StkCatType === 'Multiple Items') || (!isParcel && a.StkCatType === 'Single Item'))
            .map(d => {
                d.WebSpecial = d.WebSpecial && parseFloat(d.WebSpecial) || 0;
                return ({
                    ...d,
                    img: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
                    colour: joinHenigArray(d, 'Colour'),
                    clarity: joinHenigArray(d, 'Clarity'),
                    cut: joinHenigArray(d, 'Cut'),
                    flourecence: joinHenigArray(d, 'flourecence'),
                    symmetry: joinHenigArray(d, 'Symmetry'),
                    polish: joinHenigArray(d, 'Polish'),
                    size: joinHenigArray(d, 'Size'),
                    availability: d.Availability | d.StkWebAvailable,
                    price: d.WebSpecial || d.price || d.ExWebTotal,
                    ppc: d.WebSpecial || d.ppc || d.ExWebTotal,
                    specialOffer: d.WebSpecial ? true : false,
                    cut: joinHenigArray(d, 'Cut'),
                    sieve: joinHenigArray(d, 'Sieve'),
                    noLongerAvailable: !diamondsDocs.find(a => a._id === d._id),
                    isCompare: compareItemsList.includes(d._id),
                })
            })

        return (<div className={classNames(style.wrapper, 'dark-support')}>

            <SecondaryNav
                value="fav"
                openDiamondSideDrawer={sideDrawerOpen}
                closeBag={this.closeBag}
                sideDrawerProps={{ row }}
            />

            <div className={style.inner}>
                <SingleAndParcelsTabs value={tabsValue} onChange={this.onTabsChange} />

                {!areDiamondsLoading && !favouritesItemsListInTab.length && <div className={style.emptyListMsg}>
                    <h2>Your {!isParcel ? 'Single' : 'Parcels'} Favourite List</h2>
                    <h3>Is Currently Empty</h3>
                </div>}

                {!areDiamondsLoading && favouritesItemsListInTab.length > 0 && <div className={style.favouriteTable}>
                    {favouritesItemsListInTab.map(item => {

                        let diamondItem = false;
                        if (isParcel && item.StkCatType === 'Multiple Items') {
                            diamondItem = item;
                        }
                        if (!isParcel && item.StkCatType === 'Single Item') {
                            diamondItem = item;
                        }
                        if (!diamondItem) return;
                        
                        if(!isParcel){
                            // if we need single labs but the item is not, exclude it
                            if(isSingleLabs && diamondItem.Source !== "Lab Grown") return;

                            // if we need single natural but the item is not, exclude it
                            if(!isSingleLabs && (diamondItem.Source === "Lab Grown" || diamondItem.StkCatName === "Lab Grown Diamonds")) return;
                        }

                        return (<div className={style.favouriteItemWrap}>


                            {item.noLongerAvailable && <i className={style.favouriteItemsClose} onClick={() => this.removeFromCompared(item)} />}

                            <div
                                className={item.noLongerAvailable && style.favouriteItemsUnavailable}
                            >
                                <FavouriteItem
                                    onCloseClick={() => this.removeFromCompared(item)}
                                    diamondItem={diamondItem}
                                    isParcel={isParcel}
                                    isUnavailable={item.noLongerAvailable}
                                    isCompare={diamondItem.isCompare}
                                    toggleCompare={value => this.toggleCompare(diamondItem._id, value)}
                                />

                                <div className={style.favouriteItemDetails}>
                                    {isAuthorised && !isParcel && <h3>
                                        {getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(diamondItem.price, false))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(this.convertToCurrency(diamondItem.price, false))).format('0,0.00').split('.')[1]}</small>
                                    </h3>}
                                    {isAuthorised && isParcel && <h3>
                                        {getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(diamondItem.ppc, true))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(this.convertToCurrency(diamondItem.ppc, true))).format('0,0.00').split('.')[1]}</small>
                                    </h3>}
                                    <ul>
                                        {diamondItem.StkCertSup &&
                                            <li>
                                                {diamondItem.StkCertSup}
                                            </li>
                                        }
                                        <li>
                                            {isParcel ? diamondItem.size || '-' : `${numeral(diamondItem.STWeight).format('0.00')}ct`}
                                        </li>
                                        <li>
                                            {joinHenigArray(diamondItem, 'Colour') || '-'}
                                        </li>
                                        <li>
                                            {joinHenigArray(diamondItem, 'Clarity') || '-'}
                                        </li>
                                    </ul>
                                </div>

                                <div className={style.favouriteItemButtons}>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => this.openBag(diamondItem)}
                                        disabled={!isAuthorised}
                                    >
                                        Add to Basket
                                    </Button>

                                    <Link to={`/diamonds/${diamondItem._id}/details`} className={classes.noDecoration}>
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="default"
                                        >
                                            View Details
                                    </Button>
                                    </Link>
                                </div>
                            </div>

                            <Link
                                className={classNames(
                                    style.moreLikeThis,
                                    item.noLongerAvailable && style.moreLikeThisUnavailable
                                )}
                                to={`/diamonds/all/${item.StkShape.toLowerCase()}`}
                            >

                                {item.noLongerAvailable && <div>Item no longer available</div>}
                                {!item.noLongerAvailable && <div>More Like This</div>}

                                <div>
                                    {item.noLongerAvailable && <img alt="" src="/images/next_hover.svg" />}
                                    {!item.noLongerAvailable && <img alt="" src="/images/next.svg" />}
                                </div>
                            </Link>
                        </div>)
                    })}
                </div>}


            </div>

        </div >);
    }
}

Fav.propTypes = {
    selectFav: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
};



export default connect(
    (state) => ({
        authUser: state.auth.user,
        isAuthorised: state.auth.isAuthorised,
        favouriteItemsList: state.diamonds.favourite,
        diamondsDocs: state.diamonds.data && state.diamonds.data.docs,
        areDiamondsLoading: !state.diamonds || !state.diamonds.data || !state.diamonds.data.docs || !state.diamonds.data.docs.length,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
        compareItemsList: state.diamonds.compare,
    }),
    (dispatch) => ({
        AuthActions: bindActionCreators({ ...AuthActions }, dispatch),
        DiamondsActions: bindActionCreators({ ...DiamondsActions }, dispatch),
    })
)(withWidth()(withStyles(styles, { withTheme: true })(Fav)));
